export function openHelpDrawer(section: string) {
  window.dispatchEvent(
    new CustomEvent('help:open', { detail: { section } })
  )
}

export function openHelpChat() {
  window.dispatchEvent(new CustomEvent('help:open-chat'))
}
